// extracted by mini-css-extract-plugin
export var expertCategory = "ExpertCategory-module--expertCategory--485d4";
export var expertCategory_text = "ExpertCategory-module--expertCategory_text--52a91";
export var subHeader = "ExpertCategory-module--subHeader--182c7";